import { SVGProps, Ref, forwardRef } from 'react';

export const SunOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M8.7 15.999 7.3 16v-2.633a7.5 7.5 0 0 0 1.4 0z" fill="currentColor" />
                <path
                    d="M3.8 11.647q.352.421.794.749L2.839 14.15l-.99-.99 1.76-1.762q.091.126.19.248"
                    fill="currentColor"
                />
                <path d="m14.151 13.161-.99.99-1.756-1.755a4.5 4.5 0 0 0 .985-.997z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.275 4.006c2.607.111 3.597 1.814 3.713 3.62L12 8c0 2-1 4-4 4s-4-2-4-4l.012-.374C4.132 5.758 5.187 4 8 4zM8 5.4c-1.163 0-1.737.372-2.05.746C5.6 6.566 5.4 7.208 5.4 8s.2 1.434.55 1.854c.313.374.887.746 2.05.746s1.737-.372 2.05-.746c.35-.42.55-1.062.55-1.854s-.2-1.434-.55-1.854C9.737 5.772 9.163 5.4 8 5.4"
                    fill="currentColor"
                />
                <path d="M2.634 7.3a7 7 0 0 0 0 1.4H0V7.3z" fill="currentColor" />
                <path d="M16 8.7h-2.634a7 7 0 0 0 0-1.4H16z" fill="currentColor" />
                <path d="M4.595 3.604a4.5 4.5 0 0 0-.986.995L1.85 2.838l.99-.99z" fill="currentColor" />
                <path d="m14.151 2.838-1.761 1.76a4.543 4.543 0 0 0-.984-.995l1.756-1.755z" fill="currentColor" />
                <path d="M8.7 2.632a7.5 7.5 0 0 0-1.4 0V0h1.4z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
SunOutlinedSize16Glyph.displayName = 'SunOutlinedSize16Glyph';
